// extracted by mini-css-extract-plugin
export default {"cookieButton":"CookieSettings_cookieButton__Mp6PW","jump":"CookieSettings_jump__S-TRO"};